import Vue from 'vue'
import AnimatedNumber from "animated-number-vue";
Vue.component('animated-number', AnimatedNumber);
